import styled from 'styled-components';

import {media} from '~/shared/theme/media';
import {getLocalizationService} from '~/shared/services/localisationService';

import AmountHeadline from '../AmountHeadline';
import ConvertLoyaltyBalanceHeader from '../ConvertLoyaltyBalanceHeader';
import {ActionButton, Body, ButtonsContainer, Disclaimer, TextBlock} from '../styled';

/* The wallet hangs below the header, so clearing it is this padding's job rather than a gap between
   siblings - hence the large top value. */
const InitBody = styled(Body)`
  padding-top: 85px;
  ${media.minLargeMobile`
    padding-top: 56px;
  `}
`;

type InitScreenProps = {
  currentBalance: number;
  onConvert: () => void;
  onCancel: () => void;
};

/* The only screen of the flow that carries the header decoration - the screens that follow it report
   on the request and drop it. */
const InitScreen = ({currentBalance, onConvert, onCancel}: InitScreenProps) => {
  const {t} = getLocalizationService();

  return (
    <>
      <ConvertLoyaltyBalanceHeader />
      <InitBody data-test-id="convertLoyaltyBalanceModal_initScreen">
        <TextBlock>
          <AmountHeadline
            amount={currentBalance}
            subtitle={t('tap_and_save_convert_amount_subtitle')}
            data-test-id="convertLoyaltyBalanceModal_amount"
          />
          <Disclaimer id="modal-content">{t('tap_and_save_convert_disclaimer')}</Disclaimer>
        </TextBlock>
        <ButtonsContainer>
          <ActionButton
            variant="primaryLarge"
            data-test-id="convertLoyaltyBalanceModal_convertButton"
            onClick={onConvert}
          >
            {t('tap_and_save_convert_to_credit')}
          </ActionButton>
          <ActionButton
            variant="outlineLarge"
            data-test-id="convertLoyaltyBalanceModal_cancelButton"
            onClick={onCancel}
          >
            {t('cancel')}
          </ActionButton>
        </ButtonsContainer>
      </InitBody>
    </>
  );
};

export default InitScreen;
